import PropTypes from 'prop-types';

export * from './issue-proptypes';
export * from './attachment-proptypes';
export * from './pushpin-proptypes';

export const objectType = PropTypes.object;
export const arrayType = PropTypes.array;

export const childrenType = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node,
]);

export const paginationPropType = PropTypes.shape({
  meta: PropTypes.object,
  links: PropTypes.object,
});
